// Anwendungs-Icons an einer Stelle: zuerst die mitgelieferte Bibliothek (die
// Produkt-Icons der haeufigsten Programme), dann der Backend-Endpunkt
// (Recorder-Bild, sonst Favicon der Produkt-/Hersteller-Domain), zuletzt der
// Anfangsbuchstabe im Frontend. Nutzerbefund 03.09.2026: Favicons des
// Hersteller-Roots zeigten fuer Teams, Outlook und PowerPoint nur das
// Microsoft-Logo - die Bibliothek geht deshalb vor.
// Fuer Programme ohne Bibliotheks-Icon sucht Pax AI im Appname-Mapping die Produkt-
// Domain; deren Favicon holt das Backend (app_icons.py).
const LOCAL_ICONS = [
  ["outlook", "/img/assistant/apps/outlook.svg"],
  ["excel", "/img/assistant/apps/excel.svg"],
  ["winword", "/img/programIcons/winword.svg"],
  ["word", "/img/programIcons/winword.svg"],
  ["powerpnt", "/img/programIcons/powerpnt.svg"],
  ["powerpoint", "/img/programIcons/powerpnt.svg"],
  ["acrord32", "/img/assistant/apps/acrobat.svg"],
  ["acrobat", "/img/assistant/apps/acrobat.svg"],
  ["explorer", "/img/programIcons/explorer.svg"],
  ["chrome", "/img/programIcons/chrome.svg"],
  ["msedge", "/img/assistant/apps/edge.svg"],
  ["edge", "/img/assistant/apps/edge.svg"],
  ["firefox", "/img/assistant/apps/firefox.svg"],
  ["saplogon", "/img/assistant/apps/sap.svg"],
  ["sap", "/img/assistant/apps/sap.svg"],
  ["salesforce", "/img/assistant/apps/salesforce.svg"],
  ["datev", "/img/assistant/apps/datev.svg"],
  ["ssms", "/img/programIcons/ssms.svg"],
];

// Icon der Bibliothek fuer einen technischen oder Klarnamen, sonst "".
// Websites (Punkt im Namen) haben kein Bibliotheks-Icon: ihr Favicon kommt vom Backend.
export function localAppIcon(...names) {
  for (const raw of names) {
    const name = `${raw || ""}`.trim().toLowerCase();
    if (!name || name.includes(".")) continue;
    const hit = LOCAL_ICONS.find(([keyword]) => name.includes(keyword));
    if (hit) return hit[1];
  }
  return "";
}

// Vollstaendige Icon-URL: Bibliothek vor Backend. `iconDomain` (Hersteller-Domain
// aus dem Mapping) bricht den Browser-Cache, wenn sich das Icon aendert.
export function appIconUrl(applicationname, { clearname = "", iconDomain = "" } = {}) {
  const local = localAppIcon(applicationname, clearname);
  if (local) return local;
  const domain = iconDomain ? `&d=${encodeURIComponent(iconDomain)}` : "";
  console.log({ applicationname, clearname, iconDomain });
  return `/api/damprojects/app-icon?application=${encodeURIComponent(applicationname || "")}${domain}`;
}
